<template>
  <div class="row mt-2">
    <div class="col-12 mb-4">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              :to="{ name: 'coachBillingCoordinatorPendingBills'}"
              :class="{ active: $route.name === 'coachBillingCoordinatorPendingBills'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            Ausstehende Rechnungent
          </router-link>
          <router-link
              :to="{ name: 'coachBillingCoordinatorRejectedBills'}"
              :class="{ active: $route.name === 'coachBillingCoordinatorRejectedBills'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            Rechnungen abgelehnt
            <span v-if="countUnreadMessageForCoordinator > 0"
                  style="
                      position:absolute;
                      top:0;
                      right: 0;
                      font-size: 8px;
                      padding: 3px 8px;
                      background-color: #DC3545FF;
                      color: white;
                      border-radius: 11px;">!</span>
          </router-link>
          <router-link
              :to="{ name: 'coachBillingCoordinatorExistingBills'}"
              :class="{ active: $route.name === 'coachBillingCoordinatorExistingBills'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            Rechnungen erstellt
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
  countUnreadMessageForCoordinator: {
        type: Number,
        required: true,
      },
    },
);

const countUnreadMessageForCoordinator = toRefs(props)[ 'countUnreadMessageForCoordinator' ];

</script>

<style scoped>

</style>